import {ParcelDependencyContainer} from "@/rawdogjs/src/core/ParcelDependencyContainer";
import {Router} from "@/rawdogjs/src/router";
import {UrlSanitizer} from "@/rawdogjs/src/shared/UrlSanitizer";
import {UserStore} from "./data/stores/UserStore";
import {TenantProfileStore} from "./data/stores/TenantProfileStore";
import {BookingStore} from "./data/stores/BookingStore";
import {AuthenticationManager} from "./services/api/base/AuthenticationManager";
import {BearerTokenApi} from "./services/api/base/BearerTokenApi";
import {ParcelWebHttpClient} from "./services/api/base/ParcelWebHttpClient";
import {TenantApi} from "./services/api/base/TenantApi";
import {TenantProfileApi} from "./services/api/base/TenantProfileApi";
import {BookingApi} from "./services/api/base/BookingApi";
import {HandleApi} from "./services/api/base/HandleApi";
import {AlertService} from "./services/AlertService";
import {CookieManager} from "./components/signUp/CookieManager";

export class RegisterDependencies {
    static container: ParcelDependencyContainer;

    public static register(url:string, env:any, container: ParcelDependencyContainer, router: Router) {
        
        const userStore = UserStore.getInstance();

        this.container = container;

        this.container.register("env", () =>
            env
        );

        this.container.register("UserStore", () =>
            userStore
        );
        
        this.container.register('AlertService', ()=>{
           return new AlertService(); 
        });

        this.container.register("CookieManager", () => {
            return new CookieManager();
        });


        this.container.register("TenantProfileStore", () =>
            TenantProfileStore.getInstance()
        );

        this.container.register("BookingStore", () =>
            BookingStore.getInstance(router)
        );

        this.container.register('UrlSanitizer', () => {
            return new UrlSanitizer();
        });

        this.container.register("AuthenticationManager", () => {
                return new AuthenticationManager(
                    userStore,
                    router,
                    new BearerTokenApi(
                        router,
                        new ParcelWebHttpClient(),
                        null,
                        url
                    )
                )
            }
        );

        this.container.register("BearerTokenApi", () => {
                const authenticationManager = this.container.resolve<AuthenticationManager>('AuthenticationManager');

                return new BearerTokenApi(
                    router,
                    new ParcelWebHttpClient(),
                    authenticationManager,
                    url
                )
            }
        );

        this.container.register("TenantApi", () => {
                const bearerToken = this.container.resolve<BearerTokenApi>('BearerTokenApi');
                return new TenantApi(
                    router,
                    new ParcelWebHttpClient(),
                    new AuthenticationManager(userStore, router, bearerToken),
                    url
                )
            }
        );


        this.container.register("TenantProfileApi", () => {
                const bearerToken = this.container.resolve<BearerTokenApi>('BearerTokenApi');
                return new TenantProfileApi(
                    router,
                    new ParcelWebHttpClient(),
                    new AuthenticationManager(userStore, router, bearerToken),
                    url
                )
            }
        );


        this.container.register("BookingApi", () => {
                const bearerToken = this.container.resolve<BearerTokenApi>('BearerTokenApi');
                return new BookingApi(
                    router,
                    new ParcelWebHttpClient(),
                    new AuthenticationManager(userStore, router, bearerToken),
                    url
                )
            }
        );


        this.container.register("HandleApi", () => {
                const bearerToken = this.container.resolve<BearerTokenApi>('BearerTokenApi');
                return new HandleApi(
                    router,
                    new ParcelWebHttpClient(),
                    new AuthenticationManager(userStore, router, bearerToken),
                    url
                )
            }
        );

    }

}